import React from "react";
import { Pressable, Text, StyleSheet } from "react-native";
import { REGISTRY_SETUP_COLORS } from "./RegistrySetupModal";

const RegistrySetupButton = ({ label, onPress, disabled = false, variant = "primary" }) => {
	const isPrimary = variant === "primary";
	return (
		<Pressable
			style={[styles.button, isPrimary ? styles.primary : styles.secondary, disabled && styles.disabled]}
			onPress={onPress}
			disabled={disabled}
			accessibilityRole="button"
			accessibilityState={{ disabled }}
		>
			<Text style={[styles.label, isPrimary ? styles.primaryLabel : styles.secondaryLabel]}>{label}</Text>
		</Pressable>
	);
};

const styles = StyleSheet.create({
	button: {
		minHeight: 48,
		paddingHorizontal: 24,
		borderRadius: 24,
		alignItems: "center",
		justifyContent: "center",
		borderWidth: 2,
		borderColor: REGISTRY_SETUP_COLORS.green,
	},
	primary: {
		backgroundColor: REGISTRY_SETUP_COLORS.green,
	},
	secondary: {
		backgroundColor: "transparent",
	},
	disabled: {
		opacity: 0.45,
	},
	label: {
		fontSize: 16,
		fontWeight: "600",
	},
	primaryLabel: {
		color: "#fff",
	},
	secondaryLabel: {
		color: REGISTRY_SETUP_COLORS.green,
	},
});

export default RegistrySetupButton;
